module.exports = __webpack_public_path__ + "static/media/Android.fc4675e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/Android.png
// module id = 127
// module chunks = 0